const ImportantMessage = () => {
  return (
    <>
      <li>Please ensure booking details are correct before submitting.</li>
      <li>
        Booking once confirmed cannot be amended and the payment will not be
        refunded.
      </li>
      <li>
        Please be informed that each passenger is entitled to carry-on 1
        standard luggage only.
      </li>
      <li>
        Carry-on Baggage Prohibited Items includes Surfboard and Golf bags.
      </li>
      <li>There will not be any refund or exchange after payment is made.</li>
      <li>
        Travelers should note that when making a reservation, the booking time
        should be
      </li>
      <div className="md:ml-[22px]">
        based on their Flight ETA + 45 mins to ensure there is sufficient time
        for clearance.
      </div>
      <li>
        15 mins grace period from booked time. No refund will be given after 15
        mins
      </li>
      <div className="md:ml-[22px]">
        and passenger will be considered as no show.
      </div>
    </>
  );
};

export default ImportantMessage;
